module.exports = __webpack_public_path__ + "static/media/calendar.75724195.svg";